import ListErrors from './ListErrors';
import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  EDITOR_PAGE_LOADED,
  ARTICLE_SUBMITTED,
  EDITOR_PAGE_UNLOADED,
  UPDATE_FIELD_EDITOR
} from '../constants/actionTypes';
import './editor.css';

const mapStateToProps = state => ({
  ...state.editor,
});

const mapDispatchToProps = dispatch => ({
  onLoad: payload =>
    dispatch({ type: EDITOR_PAGE_LOADED, payload }),
  onSubmit: (payload, handle) =>
    dispatch({ type: ARTICLE_SUBMITTED, payload, handle }),
  onUnload: payload =>
    dispatch({ type: EDITOR_PAGE_UNLOADED }),
  onUpdateField: (key, value) =>
    dispatch({ type: UPDATE_FIELD_EDITOR, key, value })
});

class Editor extends React.Component {
  constructor() {
    super();

    const updateFieldEvent =
      key => ev => this.props.onUpdateField(key, ev.target.value);
    this.changeBody = updateFieldEvent('body');

    this.submitForm = ev => {
      ev.preventDefault();
      const promise = agent.Articles.create({
        content: this.props.body,
        boardId: this.props.id
      });
      this.props.onSubmit(promise, this.props.handle);
    };
  }

  componentWillMount() {
    this.props.onLoad(agent.Profile.get(this.props.match.params.username))
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  render() {
    return (
      <div className="container-background">
        <div className="editor-page">
          <div className="editor-header">
            <div className="editor-header-label">
              <Link className="header-1"
                to={`/${this.props.match.params.username}`}>
                <i className='bx bx-left-arrow-alt'></i>
              </Link>
              <div className="header-2">Submit a Question to</div>
              <div className="header-3"></div>
            </div>
            <span className="editor-header-name">{this.props.name}</span>
          </div>
          <div className="editor-body">
            <textarea
              autoFocus
              rows="12"
              placeholder={this.props.sampleQuestion}
              value={this.props.body}
              onChange={this.changeBody}>
            </textarea>
            <div className="editor-footer">
              <div>{140 - (this.props.body ? this.props.body.length : 0)} characters left</div>
              <i className='bx bxs-send' onClick={this.submitForm} ></i>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Editor);



// WEBPACK FOOTER //
// ./src/components/Editor.js